(() => {
  const scrolls = document.querySelectorAll('.card__media-scroll');
  for (const scroll of scrolls) {
    let isDown = false;
    let startX = 0;
    let scrollLeft = 0;
    let lastX = 0;
    let velocity = 0;
    let rafId = null;

    const stopMomentum = () => { if (rafId) { cancelAnimationFrame(rafId); rafId = null; } };

    const momentum = () => {
      if (Math.abs(velocity) < 0.5) {
        scroll.classList.remove('is-dragging');
        rafId = null;
        return;
      }
      scroll.scrollLeft -= velocity;
      velocity *= 0.82;
      rafId = requestAnimationFrame(momentum);
    };

    scroll.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse') return;
      stopMomentum();
      isDown = true;
      scroll.classList.add('is-dragging');
      startX = e.clientX;
      lastX = e.clientX;
      scrollLeft = scroll.scrollLeft;
      velocity = 0;
      scroll.setPointerCapture(e.pointerId);
    });

    scroll.addEventListener('pointermove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const walk = (e.clientX - startX) * 2;
      scroll.scrollLeft = scrollLeft - walk;
      velocity = (e.clientX - lastX) * 2;
      lastX = e.clientX;
    });

    const end = () => {
      if (!isDown) return;
      isDown = false;
      if (Math.abs(velocity) > 2) {
        rafId = requestAnimationFrame(momentum);
      } else {
        scroll.classList.remove('is-dragging');
      }
    };
    scroll.addEventListener('pointerup', end);
    scroll.addEventListener('pointercancel', end);

    scroll.addEventListener('click', (e) => {
      if (Math.abs(e.clientX - startX) > 5) {
        e.preventDefault();
        e.stopPropagation();
      }
    });
  }
})();
